<template>
<div class="daoh2">
<!--    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">-->
<!--        <router-link v-for="item1 in item" :key="item1.id" :to="item1.path" >-->
<!--            <el-menu-item :index="item1.id">-->
<!--                <span slot="title">{{item1.label}}</span>-->
<!--            </el-menu-item>-->
<!--        </router-link>-->
<!--    </el-menu>-->
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      isCollapse: false,
      item:[],
      items_list1:[
          {
            id:'2001',
            label: '项目管理',
            icon: 'mdi-home-outline ',
            path:'/pindex/index',
            pid:2,
          },
          {
            id:'2002',
            label: '房产管理',
            icon: 'mdi-archive-outline ',
            path:'/pindex/House',
            pid:2,
          },
          {
            id:'2003',
            label: '房产导入',
            icon: 'mdi-archive-outline ',
            path:'/pindex/Import',
            pid:2,
          },
          {
            id:'2004',
            label: '导入审核',
            icon: 'mdi-archive-outline ',
            path:'/pindex/Examine',
            pid:2,
          },
          {
            id:'2005',
            label: '费用设置',
            icon: 'mdi-archive-outline ',
            path:'/pindex/Charge',
            pid:2,
          },
          {
            id:'2009',
            label: '分摊费用',
            icon: 'mdi-archive-outline ',
            path:'/pindex/Share',
            pid:2,
          },
          {
            id:'2010',
            label: '分摊设置',
            icon: 'mdi-archive-outline ',
            path:'/pindex/ShareSetup',
            pid:2,
          },
          {
            id:'2006',
            label: '费用分类',
            icon: 'mdi-archive-outline ',
            path:'/pindex/Type',
            pid:2,
          },
          {
            id:'2007',
            label: '区域管理',
            icon: 'mdi-archive-outline ',
            path:'/pindex/region',
            pid:2,
          },
          {
            id:'2008',
            label: '新视窗导入',
            icon: 'mdi-archive-outline ',
            path:'/pindex/xsc/xsc',
            pid:2,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=2',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
    },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/project.vue